<template>
  <div class="w-full ao__mt">
    <iframe
      class="ao__media ao__media--16-9"
      :src="getSrc()"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script setup lang="ts">
const {payload} = defineProps<{
  payload?: any
}>()

const getSrc = () => {
  // TODO - base url from config
  return `https://www.youtube.com/embed/${payload.attributes.videoId}`
}
</script>

<style lang="postcss" scoped>
/*.video-container {*/
/*  @apply relative w-full;*/
/*  padding-bottom: 56.25%;*/
/*}*/

/*.video {*/
/*  position: absolute;*/
/*  top: 0;*/
/*  left: 0;*/
/*  width: 100%;*/
/*  height: 100%;*/
/*  border: 0;*/
/*}*/
</style>
